<template>
  <div class="modal fade" id="add-ip" tabindex="-1" aria-hidden="true">
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body">
          <LoadingElement v-if="loading" />
          <button
            type="button"
            class="btn-close"
            id="add-ip-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
          <div class="row g-6">
            <div class="col-12">
              <label class="form-label" for="">{{
                $t("ip_addresses.ip_address")
              }}</label>
              <input
                type="text"
                class="form-control"
                @input="validate"
                v-model="public_ip.ip_address"
                placeholder="X.X.X.X"
                :class="{ 'is-invalid': errors.ip_address }"
              />
              <div v-if="errors.ip_address" class="invalid-feedback">
                {{ errors.ip_address }}
              </div>
            </div>
            <div class="col-12">
              <label class="form-label" for="">{{
                $t("ip_addresses.ports_range_length")
              }}</label>
              <input
                type="number"
                class="form-control"
                v-model="public_ip.division_ports_count"
                @input="validate"
                :placeholder="$t('ip_addresses.ports_range_length')"
              />
            </div>
            <div class="col-12">
              <label class="form-label" for="">{{
                $t("ip_addresses.ranges_count")
              }}</label>
              <input
                type="number"
                class="form-control"
                disabled
                :value="Math.floor(65535 / public_ip.division_ports_count)"
              />
            </div>
            <div class="col-12" v-if="error_message"">
              {{ error_message }}
            </div>

            <div class="col-12 d-flex justify-content-end">
              <button class="btn btn-success" @click.prevent="store" :disabled="!validated">{{ public_ip.id ? $t("control.save") : $t("control.add") }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "ipAdd",
  data() {
    return {
      error: "",
      message: "",
      error_message: "",
      public_ip: {
        ip_address: "",
        division_ports_count: 1000,
        count: 655,
      },
      errors: {
        ip_address: null,
        division_ports_count: null,
      },
      validated: false,
      loading: false,
    };
  },
  async created() {
    this.loading = true;
    if (this.$route.query.public_ip_id) {
      await this.fetchPublicIp(this.$route.query.public_ip_id);
    }
    this.loading = false;
  },
  methods: {
    async fetchPublicIp(id) {
      const response = await axios.get(`ip/public/${id}`);
      if (response.status == 200) {
        this.public_ip = response.data.data;
      }
    },
    async store() {
      if (this.public_ip.id) {
        const response = await axios.post(
          `ip/public/${this.public_ip.id}`,
          this.public_ip
        );
        if (response.status == 200) {
          document.getElementById("add-ip-close").click();
          this.$notify({
            text: this.$t('messages.ip_updated_successfully'),
            type: "success",
          });
          this.$emit("updated", response.data);
        }
      } else {
        const response = await axios.post("ip/public", this.public_ip);
        if (response.status == 200) {
          document.getElementById("add-ip-close").click();
          this.$notify({
            text: this.$t('messages.ip_created_successfully'),
            type: "success",
          });
            this.$emit("updated", response.data);
        } else if (response.status == 210) {
          this.validated = false;
          this.error_message = this.$t("errors.ip_addresses.ips_error");
        }
      }
    },
    validate() {
      this.errors.ip_address = null;
      this.errors.division_ports_count = null;
      this.validated = true;
      if (
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
          this.public_ip.ip_address
        ) == false
      ) {
        this.validated = false;
        this.errors.ip_address = this.$t("errors.accounts.invalid_ip");
      }
    },
  },
};
</script>
